<ion-content scrollY="true">
  <ion-fab vertical="top" horizontal="start" slot="fixed">
    <ion-icon name="arrow-back" class="close-arrow" (click)="goBack()"></ion-icon>
  </ion-fab>
  <div>
    <h1>{{ "pre-auth.Verification" | translate }}</h1>
    <h5 class="preauthvalid">
      {{ "pre-auth.valid" | translate }}
    </h5>
    <p class="authproof" [innerHTML]="'pre-auth.proof' | translate"></p>
    <h6 [innerHTML]="'pre-auth.account' | translate"></h6>

    <div class="timer">
      <div class="d-flex">
        <img src="../../../assets/icon/lock key.png" alt="" class="lock" />
        <p>{{'add-payment.Secure'|translate}}</p>
      </div>
      <div>{{ "add-card.time_left" | translate }}: <span #timer></span></div>
    </div>
    <div class="payment-add-form"
      [ngStyle]="{ visibility: !isPaymentDone ? 'hidden' : 'visible', height: !isPaymentDone ? '0px' : '100vh', 'pointer-events': !isPaymentDone ? 'none' : 'auto' }">
      <iframe style="border: 0; width: 100%; height: 100vh; padding: 1vh" #iframe id="myCustomIframe1"
        name="myCustomIframe1" (load)="load(iframe)"
        sandbox="allow-forms allow-modals allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation">
      </iframe>
    </div>
  </div>

  @if (isCheckOutCom) {
<div style="
    padding: 0.3vh;
    border-radius: 2vh;
    min-height: 25vh;
    width: 97%;
    margin-left: 1.5%;
    margin-top: 1vh;
    height: auto;
    position: relative;
    background-color: #fff;
    " class="checkout_gateway">
      @if (isCheckoutComform) {
        <form id="payment-form" (submit)="onSubmit($event)">
          <ng-container>
            <div class="one-liner" [class.flow-entry]="useJackpotTriggerCheckoutFlow">
              @if (useJackpotTriggerCheckoutFlow) {
                <div id="cko-flow-container" class="cko-flow-container"></div>
              } @else {
                <div class="card-frame"></div>
              }
            </div>
            @if (errorMessage) {
              <div class="message">
                @if (isCheckoutLoadingMessage(errorMessage) && showCheckOutComSpinner && !checkoutFlowReady) {
                  <ion-spinner name="lines-small" class="checkout-inline-spinner"></ion-spinner>
                }
                <p [ngClass]="isCheckoutLoadingMessage(errorMessage) ? 'loading-message' : 'error-message'">{{ errorMessage }}</p>
              </div>
            }
          </ng-container>
        </form>
      }
      <iframe
        [ngStyle]="{ height: isCheckoutComform ? '0' : '60vh', 'min-height': isCheckoutComform ? '0' : '50vh', 'pointer-events': isCheckoutComform ? 'none' : 'auto' }"
        style="border: 0; width: 100%; padding: 1vh;"
        id="checkoutAuthorizationIframe"
        name="checkoutAuthorizationIframe"
        [src]="redirectlink"
        #checkOutIframe>
      </iframe>
    </div>
  }

  @if (!isPaymentDone && isPaymill) {
    <div class="payment-add-form"
      [ngStyle]="{ visibility: !isPaymentDone ? 'visible' : 'hidden', height: !isPaymentDone ? '100vh' : '0px' }">
      <form action="{{ origin + '/r' }}" class="paymentWidgets" id="paymentForm" data-brands="VISA MASTER"></form>
    </div>
  }

<!-- </div> -->
</ion-content>
